import React from 'react';

function About({ onBack }) {
  return (
    <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <button
        onClick={onBack}
        style={{
          marginBottom: '20px',
          padding: '10px 20px',
          background: '#1890ff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '1em',
        }}
      >
        ← 返回主页
      </button>

      <h1 style={{ fontSize: '2.5em', marginBottom: '30px', color: '#333' }}>关于我们</h1>
      
      <div style={{ lineHeight: '1.8', fontSize: '1.1em', color: '#555' }}>
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.8em', color: '#1890ff', marginBottom: '15px' }}>削词侠的使命</h2>
          <p>
            削词侠（XIAOCIXIA）是一款专业的英语词汇学习平台。覆盖小学、初中、高中、四六级、考研、托福、雅思、GRE全阶段词汇，采用分级不重复的科学方法。独创的“削词”功能，通过简单有趣的重复练习，帮助用户高效掌握英语单词。智能保存学习进度，提供个性化词汇记忆方案。
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.8em', color: '#1890ff', marginBottom: '15px' }}>核心特色</h2>
          <ul style={{ paddingLeft: '20px' }}>
            <li style={{ marginBottom: '10px' }}>
              <strong>智能削词系统：</strong>已掌握的单词可以&ldquo;削掉&rdquo;，专注学习未掌握词汇
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>科学记忆算法：</strong>基于艾宾浩斯遗忘曲线，优化复习时间
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>分级学习：</strong>从小学到GRE，覆盖全阶段词汇需求
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>双语发音：</strong>支持美式和英式发音，音标标注清晰
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>云端同步：</strong>学习进度实时保存，多设备无缝切换
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.8em', color: '#1890ff', marginBottom: '15px' }}>我们的愿景</h2>
          <p>
            我们希望让英语学习不再是简单的死记硬背，而是一个智能化、个性化的过程。
            通过技术创新和教育理念的结合，帮助每一位学习者找到最适合自己的学习路径。
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: '1.8em', color: '#1890ff', marginBottom: '15px' }}>版本信息</h2>
          <p>当前版本：v1.0</p>
          <p>更新日期：2025年10月</p>
        </section>
      </div>
    </div>
  );
}

export default About;